import React, { useContext } from 'react';
import { KFLButton, KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import { connect } from 'react-redux';
import { AppKeys } from '../../core/localization';
import * as Register from '../../modules/dialogs/register';
import DialogHeader from '../shared/dialog/dialogHeader';
import DialogFooter from '../shared/dialog/dialogFooter';
import { ReduxState } from '../../interfaces';
import RegisterForm from './registerForm';
import RegisterList from './registerList';
import Spinner from '../shared/spinner';
import DialogSection from '../shared/dialog/dialogSection';
import { LocaleCtx } from '../../contexts/locale.context';
import useDialog from '../shared/dialog/useDialog';
import './registerDialog.scss';

type StateProps = Register.State;

type Props = StateProps;

const RegisterDialog: React.FC<Props> = (props) => {
  const { setDialog } = useDialog();
  const { translate } = useContext(LocaleCtx);

  const msgRegisterHeader = translate(AppKeys.Register_Header);
  const msgClearBtn = translate(AppKeys.Btn_Clear);
  const msgRegisterBtn = translate(AppKeys.Btn_Register);
  const msgRegistering = translate(AppKeys.Register_Updating);

  const onClick = () => Register.registerDevices(props.keys);
  const registerButton = (
    <KFLButton
      id="dg-register-bt-register"
      key="dg-register-bt-register"
      onClick={onClick}
      disabled={props.keys.length === 0}
    >
      {msgRegisterBtn}
    </KFLButton>
  );

  const cancelButton = (
    <KFLButton
      id="dg-register-bt-clear"
      key="dg-register-bt-clear"
      variant="borderless"
      onClick={() => Register.clearAllDevice()}
      disabled={props.keys.length === 0}
    >
      {msgClearBtn}
    </KFLButton>
  );

  const footerText = props.isFetching ? (
    <Spinner label={msgRegistering} iconSize={20} />
  ) : (
    <></>
  );

  return (
    <KFLDialog
      header={
        <DialogHeader
          title={msgRegisterHeader}
          fnCloseDialog={() => setDialog?.()}
        />
      }
      sections={[
        <>
          <DialogSection>
            <RegisterForm
              editingItem={props.editingDevice}
              translate={translate}
            />
          </DialogSection>
          <DialogSection isMain scrollable>
            <RegisterList devices={props.keys} />
          </DialogSection>
        </>,
      ]}
      footer={
        <DialogFooter
          leftContent={footerText}
          buttons={[cancelButton, registerButton]}
          hideCancelBtn
          fnCloseDialog={() => setDialog?.()}
        />
      }
    />
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  ...state.dialogState.registerState,
});

export default connect(mapStateToProps)(RegisterDialog);
